import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

interface ConfigListItem {
    key: React.Key;
    text: React.ReactNode;
    radarClickName: string;
    link?: string;
    linkWithLocale?: {
        [key: string]: string;
    };
}

interface ConfigItem {
    key: React.Key;
    title: React.ReactNode;
    targetBlank?: boolean;
    // list中的元素本身也是数组，用来支持多列，如果只是一个数组元素就是展示一列
    list: ConfigListItem[][];
}

export const TermsConfig = {
    key: 'Terms',
    title: <FormattedMessage defaultMessage="Terms" />,
    targetBlank: true,
    list: [
        [
            {
                key: 'legal0',
                text: <FormattedMessage defaultMessage="Terms of Service" />,
                radarClickName: 'terms_termofservice',
                link: 'https://www.kwai.com/business/legal/0',
            },
            {
                key: 'legal1',
                text: <FormattedMessage defaultMessage="Ad Policies" />,
                radarClickName: 'terms_adpolicies',
                link: 'https://www.kwai.com/business/legal/1',
            },
            {
                key: 'legal2',
                text: <FormattedMessage defaultMessage="Privacy Policy" />,
                radarClickName: 'terms_privacypolicy',
                link: 'https://www.kwai.com/business/legal/2',
            },
        ],
    ],
};

export const HelperCenterConfig = {
    key: 'Help Center',
    title: <FormattedMessage defaultMessage="Help Center" />,
    targetBlank: true,
    list: [
        [
            {
                key: 'helpercenter_productlibrary',
                text: <FormattedMessage defaultMessage="Product Library" />,
                radarClickName: 'helpercenter_productlibrary',
                linkWithLocale: {
                    'en-US':
                        'https://docs.qingque.cn/s/home/eZQCq137qZz98sS1GnHZqQZ3V?identityId=1oEElSWqQi3&section=1286527815#section=1286527815',
                    'zh-CN':
                        'https://docs.qingque.cn/s/home/eZQBkzE5Nxu0E_5vmY3ItjksD?identityId=1oEElSWqQi3&section=1277920148#section=1277920148',
                    'pt-BR':
                        'https://docs.qingque.cn/s/home/eZQCq137qZz98sS1GnHZqQZ3V?identityId=1oEElSWqQi3&section=1286527815#section=1286527815',
                    'id-ID':
                        'https://docs.qingque.cn/s/home/eZQCq137qZz98sS1GnHZqQZ3V?identityId=1oEElSWqQi3&section=1286527815#section=1286527815',
                },
            },
            {
                key: 'helpercenter_politicalAdLibrary',
                text: <FormattedMessage defaultMessage="Political Ad Library" />,
                radarClickName: 'helpercenter_politicalAdLibrary',
                linkWithLocale: {
                    'en-US': 'https://www.kwai.com/business/adstransparency',
                    'zh-CN': 'https://www.kwai.com/business/zh-CN/adstransparency',
                    'pt-BR': 'https://www.kwai.com/business/adstransparency',
                    'id-ID': 'https://www.kwai.com/business/adstransparency',
                },
            },
            {
                key: 'helpercenter_videoguides',
                text: <FormattedMessage defaultMessage="Video Guides" />,
                radarClickName: 'helpercenter_videoguides',
                linkWithLocale: {
                    'en-US': 'https://docs.qingque.cn/s/home/eZQC5o52VvqigYQ9uFsGrNH4z?identityId=1oEElSWqQi3',
                    'zh-CN': 'https://docs.qingque.cn/s/home/eZQC6__oen_krDzBGKdgRP_Ac?identityId=1oEElSWqQi3',
                    'pt-BR': 'https://docs.qingque.cn/s/home/eZQC5o52VvqigYQ9uFsGrNH4z?identityId=1oEElSWqQi3',
                    'id-ID': 'https://docs.qingque.cn/s/home/eZQC5o52VvqigYQ9uFsGrNH4z?identityId=1oEElSWqQi3',
                },
            },
        ],
    ],
};

export const useCreatorConfig = () => {
    return {
        key: 'Creator',
        title: <FormattedMessage defaultMessage="Creator Solutions" />,
        targetBlank: true,
        list: [
            [
                {
                    key: 'creator_marketplace',
                    text: <FormattedMessage defaultMessage="Creator Marketplace" />,
                    radarClickName: 'creator_marketplace',
                    link: 'https://creatormarketplace.kwai.com/',
                },
            ],
        ],
    };
};

export const useConfigs = () => {
    const CreatorConfig = useCreatorConfig();
    return useMemo(() => [TermsConfig, HelperCenterConfig, CreatorConfig] as ConfigItem[], [CreatorConfig]);
};
